// Shared helper for calling backend endpoints guarded by @require_auth.
// The backend cryptographically verifies the Cognito **idToken** (not the
// accessToken — its audience/token_use claims fail the id-token check).
import { Auth } from 'aws-amplify';

/** Current Cognito idToken JWT, or null when there is no session. */
export async function getIdToken() {
  try {
    return (await Auth.currentSession()).getIdToken().getJwtToken();
  } catch {
    return null;
  }
}

/** Headers object carrying the idToken (plus any extra headers). */
export async function authHeaders(extra = {}) {
  const token = await getIdToken();
  return { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...extra };
}
